export default {
  // Header
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.about': 'About Us',
  'nav.process': 'Process',
  'nav.testimonials': 'Testimonials',
  'nav.contact': 'Contact',
  'nav.careers': 'Join Us',

  // Hero
  'hero.title': 'Professional Commercial Cleaning Services in Istanbul',
  'hero.subtitle': 'Providing reliable and high-quality cleaning solutions for hospitals, shopping malls, and post-construction sites since 2008. Certified team, eco-friendly products, 24/7 emergency service.',
  'hero.cta': 'Get a Free Quote',
  'hero.phone': 'Call Now',

  // Services
  'services.title': 'Our Services',
  'services.subtitle': 'Comprehensive cleaning solutions for every need',
  'services.hospital.title': 'Hospital Cleaning',
  'services.hospital.desc': 'Specialized medical facility cleaning with strict hygiene protocols and certified staff. We ensure sterile environments for patient safety.',
  'services.mall.title': 'Shopping Mall Cleaning',
  'services.mall.desc': 'Complete cleaning services for retail spaces, food courts, and common areas. Daily maintenance and deep cleaning available.',
  'services.construction.title': 'Post-Construction Cleaning',
  'services.construction.desc': 'Thorough cleaning and debris removal after construction or renovation projects. We make your space move-in ready.',
  'services.office.title': 'Office Cleaning',
  'services.office.desc': 'Daily or periodic cleaning services for corporate offices and business centers. Flexible scheduling to suit your needs.',
  'services.industrial.title': 'Industrial Cleaning',
  'services.industrial.desc': 'Heavy-duty cleaning for factories, warehouses, and industrial facilities. Specialized equipment and trained personnel.',
  'services.residential.title': 'Residential Cleaning',
  'services.residential.desc': 'Professional home cleaning services including deep cleaning and regular maintenance. Trustworthy and reliable service.',

  // Why Choose Us
  'why.title': 'Why Choose Roba Temizlik?',
  'why.subtitle': 'Your trusted partner for professional cleaning services in Istanbul',
  'why.experience.title': '15+ Years of Experience',
  'why.experience.desc': 'Serving since 2008 with proven expertise in commercial cleaning',
  'why.certified.title': 'Certified Team',
  'why.certified.desc': 'Fully trained and certified cleaning professionals with background checks',
  'why.eco.title': 'Eco-Friendly Products',
  'why.eco.desc': 'Using environmentally safe cleaning solutions that are safe for people and planet',
  'why.support.title': '24/7 Emergency Support',
  'why.support.desc': 'Emergency cleaning services available anytime, day or night',
  'why.insured.title': 'Licensed & Insured',
  'why.insured.desc': 'Full liability coverage and proper licensing for your peace of mind',
  'why.quality.title': '100% Quality Guarantee',
  'why.quality.desc': 'Complete satisfaction guaranteed on all services or we will make it right',

  // Process
  'process.title': 'Our Process',
  'process.subtitle': 'Simple steps to spotless spaces',
  'process.step1.title': 'Contact Us',
  'process.step1.desc': 'Reach out via phone, email, or contact form to discuss your cleaning needs',
  'process.step2.title': 'Site Assessment',
  'process.step2.desc': 'We visit your location and evaluate your specific cleaning requirements',
  'process.step3.title': 'Custom Quote',
  'process.step3.desc': 'Receive a detailed proposal tailored to your needs and budget',
  'process.step4.title': 'Professional Service',
  'process.step4.desc': 'Our certified team delivers exceptional results with attention to detail',

  // Testimonials
  'testimonials.title': 'What Our Clients Say',
  'testimonials.subtitle': 'Trusted by leading organizations across Istanbul',
  'testimonials.client1.name': 'Dr. Mehmet Yılmaz',
  'testimonials.client1.position': 'Hospital Director, Beşiktaş Medical Center',
  'testimonials.client1.text': 'Roba Temizlik has been maintaining our hospital for 5 years. Their attention to hygiene standards and professionalism is outstanding. They understand the critical nature of medical facility cleaning. Highly recommended!',
  'testimonials.client2.name': 'Ayşe Demir',
  'testimonials.client2.position': 'Facility Manager, Kadıköy Shopping Mall',
  'testimonials.client2.text': 'We manage a large shopping center and Roba Temizlik handles all our cleaning needs perfectly. Their team is reliable, efficient, and always professional. They work seamlessly around our operating hours.',
  'testimonials.client3.name': 'Can Öztürk',
  'testimonials.client3.position': 'Construction Manager, Maslak Projects',
  'testimonials.client3.text': 'After every project, Roba Temizlik transforms our construction sites into pristine spaces. Their post-construction cleaning is exceptional and they always meet our tight deadlines.',

  // Service Areas
  'areas.title': 'Service Areas',
  'areas.subtitle': 'Serving all districts of Istanbul with professional cleaning services',
  'areas.european': 'European Side',
  'areas.asian': 'Asian Side',
  'areas.all': 'All Istanbul Districts',
  'areas.european.districts': 'Beşiktaş, Şişli, Beyoğlu, Fatih, Bakırköy, Başakşehir, and more',
  'areas.asian.districts': 'Kadıköy, Üsküdar, Ataşehir, Maltepe, Kartal, Pendik, and more',

  // Portfolio
  'portfolio.title': 'Our Projects',
  'portfolio.subtitle': 'Recent work showcasing our expertise and commitment to excellence',
  'portfolio.project1.title': 'Private Hospital - Beşiktaş',
  'portfolio.project1.desc': 'Complete medical facility cleaning with specialized protocols and sterile environment maintenance',
  'portfolio.project2.title': 'Shopping Mall - Kadıköy',
  'portfolio.project2.desc': '15,000 sqm retail space daily maintenance including food courts and common areas',
  'portfolio.project3.title': 'Office Complex - Maslak',
  'portfolio.project3.desc': 'Corporate office cleaning for 500+ employees with flexible scheduling',
  'portfolio.project4.title': 'Residential Complex - Ataşehir',
  'portfolio.project4.desc': 'Post-construction cleaning for 200 apartments, making them move-in ready',

  // CTA
  'cta.title': 'Ready to Experience Professional Cleaning?',
  'cta.subtitle': 'Get your free quote today and discover the Roba Temizlik difference. No obligation, just honest pricing.',
  'cta.button': 'Request Free Quote',

  // Contact
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Get in touch for a free consultation and quote',
  'contact.name': 'Full Name',
  'contact.name.placeholder': 'Enter your full name',
  'contact.email': 'Email Address',
  'contact.email.placeholder': 'Enter your email address',
  'contact.phone': 'Phone Number',
  'contact.phone.placeholder': 'Enter your phone number',
  'contact.service': 'Service Type',
  'contact.service.select': 'Select a service',
  'contact.service.hospital': 'Hospital Cleaning',
  'contact.service.mall': 'Shopping Mall Cleaning',
  'contact.service.construction': 'Post-Construction Cleaning',
  'contact.service.office': 'Office Cleaning',
  'contact.service.industrial': 'Industrial Cleaning',
  'contact.service.residential': 'Residential Cleaning',
  'contact.message': 'Your Message',
  'contact.message.placeholder': 'Tell us about your cleaning needs...',
  'contact.submit': 'Send Message',
  'contact.sending': 'Sending...',
  'contact.success': 'Thank you! We will contact you soon.',
  'contact.error': 'An error occurred. Please try again.',
  'contact.info.title': 'Contact Information',
  'contact.info.address': 'Address',
  'contact.info.address.value': 'Istanbul, Turkey',
  'contact.info.phone': 'Phone',
  'contact.info.phone.value': '+90 (212) 555-0123',
  'contact.info.email': 'Email',
  'contact.info.email.value': 'info@robatemizlik.com',
  'contact.info.hours': 'Working Hours',
  'contact.info.hours.value': 'Monday - Sunday: 24/7 Emergency Service Available',

  // Careers
  'careers.title': 'Join Our Team',
  'careers.subtitle': 'Become part of the Roba Temizlik family',
  'careers.description': 'Want to join our professional team? We offer opportunities for those who want to build a career in the cleaning industry. Fill out the form and we will contact you.',
  'careers.form.title': 'Job Application Form',
  'careers.form.name': 'Full Name',
  'careers.form.name.placeholder': 'Enter your full name',
  'careers.form.phone': 'Phone Number',
  'careers.form.phone.placeholder': 'Enter your phone number',
  'careers.form.about': 'About Yourself',
  'careers.form.about.placeholder': 'Tell us about your experience, skills, and why you want to work with us... (Maximum 500 characters)',
  'careers.form.submit': 'Submit Application',
  'careers.form.sending': 'Sending...',
  'careers.form.success': 'Your application has been received! We will contact you soon.',
  'careers.form.error': 'An error occurred. Please try again.',
  'careers.benefits.title': 'Why Work With Us?',
  'careers.benefit1.title': 'Competitive Salary',
  'careers.benefit1.desc': 'Industry-leading compensation packages',
  'careers.benefit2.title': 'Training Programs',
  'careers.benefit2.desc': 'Continuous development and certification opportunities',
  'careers.benefit3.title': 'Social Benefits',
  'careers.benefit3.desc': 'Insurance and additional social benefits',
  'careers.benefit4.title': 'Career Growth',
  'careers.benefit4.desc': 'Promotion and advancement opportunities',

  // Footer
  'footer.about.title': 'About Roba Temizlik',
  'footer.about.text': 'Professional commercial cleaning services in Istanbul since 2008. We provide reliable, high-quality cleaning solutions for hospitals, shopping malls, offices, and more. Licensed, insured, and certified.',
  'footer.services.title': 'Our Services',
  'footer.quick.title': 'Quick Links',
  'footer.contact.title': 'Contact Us',
  'footer.rights': 'All rights reserved.',
  'footer.powered': 'Website Builder',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
};
